import React, { useState, useEffect } from "react";
import { Grid, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import {
  ProductCard,
  CheckFAB,
  CloseFAB,
  LocalMallFAB,
  Backdrop,
  Copyright,
  EditableTable,
} from "../components";
import { OrderContext } from "../context";
import { getOrderNum } from "../helpers";

export default (props) => {
  const { orders } = React.useContext(OrderContext);
  const [openSummary, setOpenSummary] = useState(false);
  return (
    <Grid container spacing={2}>
      <Backdrop open={openSummary} setOpen={setOpenSummary}>
        <Grid container spacing={3}>
          <Grid item xs={12} container justify="center">
            <EditableTable />
          </Grid>
          <Grid item xs={6} container justify="center">
            <CloseFAB />
          </Grid>
          <Grid item xs={6} container justify="center">
            <CheckFAB />
          </Grid>
        </Grid>
      </Backdrop>
      {props.children}
      <LocalMallFAB
        badgeContent={getOrderNum(orders)}
        onClick={() => setOpenSummary(true)}
      />
      <Copyright />
    </Grid>
  );
};
